import { Scale, Subtract, Total } from "@pdfking/math"
import { MM } from "@pdfking/quantity"
import { PlotFunction } from "@pdfking/renderer-api"

import { PALETTE } from "#constants"
import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

// The rule under the month's name
const RULE = MM(0.3)

/** Wonderwall, a wall calendar: the year big on its picture; a month under
 * its picture, the contact on a card of paper at the picture's foot from the
 * page's edge; its name ruled under, its days across in a strip at the foot,
 * on a band of paper: the picture runs over the whole page, clear round them. */
export const Wonderwall: CalendarDesign = {
  cover: PictureCover({ at: 0.35, size: 0.16 }),
  page: ({ gap, language, outer, page, short, year }, month) => {
    const picture = Region(page, 0, 0.165, 1, 1)
    const contact = Scale(short, 0.08)
    const card = {
      height: Total(contact, Scale(gap, 2)),
      width: Scale(page.width, 0.35),
      x: page.x,
      y: picture.y,
    }
    const below = Slice.under(outer, picture.y, gap)
    const [title, rest] = Slice.top(below, Scale(short, 0.07), gap)
    return [
      // All picture, carved round the card and the band of paper under it
      Area.picture(page, month, false, [
        { enum: PlotFunction.PLOT_RECT, fill_color: PALETTE.paper, position: card },
        {
          enum: PlotFunction.PLOT_RECT,
          fill_color: PALETTE.paper,
          position: { ...page, height: picture.y },
        },
      ]),
      Area.contact(
        {
          height: contact,
          width: Subtract(Total(card.x, card.width), Total(outer.x, gap)),
          x: outer.x,
          y: Total(card.y, gap),
        },
        false
      ),
      Area.title(title, month, language),
      Area.solid({ ...rest, height: RULE, y: Subtract(Total(rest.y, rest.height), RULE) }),
      Area.strip(Slice.bottom(rest, Scale(short, 0.08))[0], month, year, false),
    ]
  },
  pages: "month",
}
